import { ResourcePoolImpl } from './ResourcePoolImpl';
import { SpriteResource } from './SpriteResource';
import { SpriteData } from './SpriteData';
import { SpriteFrame } from './SpriteFrame';
import { parseRect, parseSize, parseVector2 } from './globalFunctions';
import { Vector2 } from './Vector2';
import { Rect } from './Rect';
import { NinePatchFrame } from './NinePatchFrame';
import { TextureResource } from './TextureResource';
import { Log } from './Log';
import { IResourceCache } from './IResourceCache';

export class SpriteResourcePool extends ResourcePoolImpl<SpriteResource, SpriteData> {
  private _resourceCache: IResourceCache;

  constructor(resourceCache: IResourceCache) {
    super();
    this._resourceCache = resourceCache;
  }

  createResource(resoruceId: string): SpriteResource {
    return new SpriteResource(resoruceId);
  }

  loadData(data: string): SpriteData {
    const json = JSON.parse(data);

    const resource = json['resource'];
    const meta = resource['meta'];

    const framesJson = resource['frames'];
    const frames: SpriteFrame[] = new Array<SpriteFrame>(framesJson.length);

    for (let i = 0; i < framesJson.length; ++i) {
      const frameJson = framesJson[i];
      const frame = parseRect(frameJson['frame'], Rect.Empty);
      const offset = parseVector2(frameJson['spriteSourceSize'], Vector2.Zero);
      const size = parseSize(frameJson['sourceSize'], Vector2.Zero);

      frames[i] = Object.prototype.hasOwnProperty.call(frameJson, 'ninePatch')
        ? new NinePatchFrame(frame, offset, size, parseRect(frameJson['ninePatch'], Rect.Empty))
        : new SpriteFrame(frame, offset, size);
    }

    const textureResource = meta['image'];
    const texture = this._resourceCache.getResource<TextureResource>(
      TextureResource.TypeId,
      textureResource
    )!;
    if (!texture) {
      Log.Error(`[SpriteResourcePool] can't resolve texture: ${textureResource}`);
    }

    return new SpriteData(texture, frames);
  }
}
